import { type ReactNode } from 'react'

import { Icon } from '@/components/icons/Icon'
import { type BrandType } from '@/defs/brand'
import { type DistributiveOmit } from '@/defs/misc'
import { cn } from '@/utils/commonUtil'

import { ButtonRoot, type Props as RootProps } from '../ButtonRoot/ButtonRoot'

import styles from './ButtonDefault.module.scss'

type Props = {
  boxshadow?: 'none'
  centered?: boolean
  children: ReactNode
  colorScheme?:
    | 'selected'
    | 'content'
    | 'light'
    | 'dark'
    | 'surface'
    | 'subtle'
    | 'muted'
    | 'warning'
    | 'alert'
    | 'success'
    | 'patreon'
    | BrandType
  disabled?: boolean
  fontNormal?: boolean
  hover?: 'none'
  justifyContent?: 'left' | 'right' | 'center'
  loading?: boolean
  maxwidth?: boolean
  padding?: 'none'
  size?: 'xs' | 'sm' | 'lg'
  textshadow?: boolean
  variant?: 'outline' | 'cardFiltersButton'
} & DistributiveOmit<RootProps, 'className'>

export const ButtonDefault = ({
  boxshadow,
  centered,
  children,
  colorScheme,
  fontNormal,
  hover,
  justifyContent,
  loading,
  maxwidth,
  padding,
  size,
  textshadow,
  variant,
  ...props
}: Props) => (
  <ButtonRoot
    aria-busy={loading || undefined}
    className={cn(styles.container, {
      boxshadow,
      centered,
      colorScheme,
      disabled: props.disabled || loading,
      fontNormal,
      hover,
      justifyContent,
      loading,
      maxwidth,
      padding,
      size,
      styles,
      textshadow,
      variant,
    })}
    {...props}
  >
    <span className={styles.label}>{children}</span>
    {loading && (
      <span className={styles.iconLoading}>
        <Icon name='spinner' />
      </span>
    )}
  </ButtonRoot>
)
